<div [formGroup]="form">
  <ng-container
    [formGroupName]="i"
    *ngFor="let agg of form?.controls; let i = index">
    <div class="repeatable-card-fields">
      <mat-form-field>
        <input
          matInput
          placeholder="Data (AGGD)"
          formControlName="AGGD">
      </mat-form-field>
      <mat-form-field>
        <input
          matInput
          placeholder="Nome (AGGN)"
          formControlName="AGGN">
      </mat-form-field>
      <button
        *roleVisibility="['create', 'update']; classNames: classNames"
        mat-icon-button
        type="button"
        (click)="removeHandler(i)">
        <mat-icon>delete</mat-icon>
      </button>
    </div>
  </ng-container>
  <button
    *roleVisibility="['create', 'update']; classNames: classNames"
    mat-raised-button
    type="button"
    (click)="addHandler()">
    {{ 'Aggiungi aggiornamento / revisione' | translate }}
  </button>
</div>
